export const SET_VOTEFRIEND_INDEX = 'SET_VOTEFRIEND_INDEX'
export const GET_VOTEFRIEND_INDEX = 'GET_VOTEFRIEND_INDEX'
export const RECEIVED_VOTEFRIEND_INDEX = 'RECEIVED_VOTEFRIEND_INDEX'

export const SET_VOTEFRIEND_INDEX_SELECTED = 'SET_VOTEFRIEND_INDEX_SELECTED'
export const GET_VOTEFRIEND_INDEX_SELECTED = 'GET_VOTEFRIEND_INDEX_SELECTED'

export const SET_VOTEFRIEND_LABELS = 'SET_VOTEFRIEND_LABELS'
export const GET_VOTEFRIEND_LABELS = 'GET_VOTEFRIEND_LABELS'
export const RECEIVED_VOTEFRIEND_LABELS = 'RECEIVED_VOTEFRIEND_LABELS'

export const POST_VOTEFRIEND_SAVE = 'POST_VOTEFRIEND_SAVE'

export const GET_VOTEFRIEND_PAGECURRENT = 'GET_VOTEFRIEND_PAGECURRENT'
export const SET_VOTEFRIEND_PAGECURRENT = 'SET_VOTEFRIEND_PAGECURRENT'

export const GET_VOTEFRIEND_MAXPAGE = 'GET_VOTEFRIEND_MAXPAGE'
export const SET_VOTEFRIEND_MAXPAGE = 'SET_VOTEFRIEND_MAXPAGE'

export const GET_VOTEFRIEND_NUMPERPAGE = 'GET_VOTEFRIEND_NUMPERPAGE'

export const SET_VOTEFRIEND_PROFILE = 'SET_VOTEFRIEND_PROFILE'
export const GET_VOTEFRIEND_PROFILE = 'GET_VOTEFRIEND_PROFILE'
export const RECEIVED_VOTEFRIEND_PROFILE = 'RECEIVED_VOTEFRIEND_PROFILE'



// WEBPACK FOOTER //
// ./src/store/modules/votefriend/mutation-types.js